import type { ExternalEntryParams } from './external-entry-params';

let pendingParams: ExternalEntryParams | undefined;

export const stashExternalEntryParams = (
  params: ExternalEntryParams | undefined,
) => {
  pendingParams = params;
};

export const takeExternalEntryParams = () => {
  const params = pendingParams;

  pendingParams = undefined;

  return params;
};
